<header class="header text-center" >
    <img src="assets/images/logo.png" alt="logo">
</header>

<section>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-10 text-center">
                <div class="boxConainer pivc-complete">
                    <img src="assets/images/pivc-complete.svg" alt="pivc-complete">
                    <h1>PIVC Completed</h1>
                    <p>
                        Thank you for completing pre-issuance<br>
                        verification for your proposal number {{ policyNumber }}. <br>
                        Our executive will get in touch with you regarding your concern.
                    </p>
                    <button *ngIf="!submitBtnHidden" type="button" class="btn btn-lg">Done</button>
                </div>
            </div>
        </div>
    </div>
</section>